<template>
  <div>
    <div
      class="breadcrumb"
      @click="
        $router.push({
          path: 'dokumen',
          query: { directory: state.listFolder.ParentDir }
        })
      "
    >
      <svg
        v-if="route.query?.directory && state.listFolder.CurrentDir"
        width="8"
        height="12"
        viewBox="0 0 8 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.2908 5.9997L6.8308 2.4597C7.01705 2.27234 7.12159 2.01889 7.12159 1.7547C7.12159 1.49052 7.01705 1.23707 6.8308 1.0497C6.73783 0.955976 6.62723 0.881582 6.50537 0.830813C6.38352 0.780044 6.25281 0.753906 6.1208 0.753906C5.98879 0.753906 5.85808 0.780044 5.73622 0.830813C5.61436 0.881582 5.50376 0.955976 5.4108 1.0497L1.1708 5.2897C1.07707 5.38267 1.00268 5.49327 0.951907 5.61513C0.901138 5.73699 0.875 5.86769 0.875 5.9997C0.875 6.13172 0.901138 6.26242 0.951907 6.38428C1.00268 6.50614 1.07707 6.61674 1.1708 6.7097L5.4108 10.9997C5.50424 11.0924 5.61505 11.1657 5.73689 11.2155C5.85873 11.2652 5.98919 11.2905 6.1208 11.2897C6.2524 11.2905 6.38287 11.2652 6.5047 11.2155C6.62654 11.1657 6.73736 11.0924 6.8308 10.9997C7.01705 10.8123 7.12159 10.5589 7.12159 10.2947C7.12159 10.0305 7.01705 9.77707 6.8308 9.5897L3.2908 5.9997Z"
          fill="#21409A"
        />
      </svg>
      <span>{{ state.listFolder.CurrentDir?.replaceAll("/", "") }}</span>
    </div>
    <div class="card-container">
      <div class="card-content">
        <div
          v-for="item in listFiles"
          :key="item.name"
          class="card-document"
          @click="
            $router.push({
              path: 'dokumen',
              query: {
                directory:
                  state.listFolder.ParentDir +
                  state.listFolder.CurrentDir +
                  item.name
              }
            })
          "
        >
          <div class="card-document__icon">
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_4751_1584)">
                <path
                  opacity="0.8"
                  d="M34.2163 21H49.0031C50.8596 21 52.6401 21.7375 53.9529 23.0503C55.2656 24.363 56.0031 26.1435 56.0031 28V47.6C56.0031 49.4565 55.2656 51.237 53.9529 52.5498C52.6401 53.8625 50.8596 54.6 49.0031 54.6H18.2031C16.3466 54.6 14.5661 53.8625 13.2534 52.5498C11.9406 51.237 11.2031 49.4565 11.2031 47.6V21C11.2031 19.1435 11.9406 17.363 13.2534 16.0503C14.5661 14.7375 16.3466 14 18.2031 14H26.1551C27.389 14.0004 28.6008 14.3269 29.6678 14.9465C30.7348 15.566 31.6191 16.4566 32.2311 17.528L34.2163 21Z"
                  fill="#A3A3A3"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M43.4016 15.3984H28.6148L26.6296 11.9264C26.0176 10.8551 25.1333 9.96447 24.0663 9.34491C22.9992 8.72536 21.7874 8.39884 20.5536 8.39844H12.6016C10.745 8.39844 8.96457 9.13594 7.65181 10.4487C6.33906 11.7614 5.60156 13.5419 5.60156 15.3984V41.9984C5.60156 43.855 6.33906 45.6354 7.65181 46.9482C8.96457 48.2609 10.745 48.9984 12.6016 48.9984H43.4016C45.2581 48.9984 47.0386 48.2609 48.3513 46.9482C49.6641 45.6354 50.4016 43.855 50.4016 41.9984V22.3984C50.4016 20.5419 49.6641 18.7614 48.3513 17.4487C47.0386 16.1359 45.2581 15.3984 43.4016 15.3984ZM12.6016 46.1984C11.4877 46.1984 10.4194 45.7559 9.63171 44.9683C8.84406 44.1806 8.40156 43.1123 8.40156 41.9984V15.3984C8.40156 14.2845 8.84406 13.2162 9.63171 12.4286C10.4194 11.6409 11.4877 11.1984 12.6016 11.1984H20.5536C21.2939 11.1987 22.021 11.3946 22.6612 11.7663C23.3014 12.1381 23.832 12.6724 24.1992 13.3152L26.5848 17.4928C26.7074 17.7075 26.8847 17.8859 27.0986 18.0098C27.3126 18.1338 27.5555 18.1989 27.8028 18.1984H43.4016C44.5155 18.1984 45.5838 18.6409 46.3714 19.4286C47.1591 20.2162 47.6016 21.2845 47.6016 22.3984V41.9984C47.6016 43.1123 47.1591 44.1806 46.3714 44.9683C45.5838 45.7559 44.5155 46.1984 43.4016 46.1984H12.6016Z"
                  fill="#303030"
                />
              </g>
              <defs>
                <clipPath id="clip0_4751_1584">
                  <rect width="56" height="56" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
          <div class="card-document__text">
            <span>{{ item.name }}</span>
          </div>
        </div>
        <div v-for="(item, index) in listImages" :key="item.name">
          <div @click="openImage(index)" class="card-image">
            <img
              :src="
                getImageUrl(
                  state.listFolder.ParentDir + state.listFolder.CurrentDir,
                  item.name
                )
              "
              alt=""
              referrerpolicy="no-referrer"
              class="img-inside-card"
            />
            <div class="content-info">
              <span class="content-name">{{ item.name }}</span>
              <span>{{ formatDate(item.modification_time) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ImageSlider
      ref="imagePreviewRef"
      :startIndex="startIndex"
      :images="images"
    />
  </div>
</template>

<script setup>
import { onMounted } from '@vue/runtime-core'
import axios from 'axios'
import { computed, reactive, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useFormatDate } from '@/composable/useFormatDate.js'
import ImageSlider from '../../../components/ImageSlider.vue'

const route = useRoute()

const formatDate = date => {
  return useFormatDate(date)
}

const urlImage = ref(
  `${process.env.VUE_APP_API_URL}statics/content/publicdocument`
)

const state = reactive({
  listFolder: {},
  dir: ''
})

const startIndex = ref(0)
const imagePreviewRef = ref(null)

const openImage = index => {
  startIndex.value = index
  imagePreviewRef.value.show()
}

const getListFolder = async (id = '') => {
  const {
    data: { data }
  } = await axios.get('content/document/public?directory=' + id)
  state.listFolder = await data
  state.listFolder.ParentDir = data.ParentDir.replace('/', '')
  state.listFolder.CurrentDir = data.CurrentDir
    ? '/'.concat(data.CurrentDir).concat('/')
    : ''
}

const getImageUrl = (dir, name) => {
  return urlImage.value + `${dir}/${name}`
}

const isImageFile = filename => {
  if (
    filename.includes('.jpeg') ||
    filename.includes('.jpg') ||
    filename.includes('.png')
  ) {
    return true
  }
}

onMounted(() => {
  getListFolder(route.query?.directory || '')
})

watch(
  () => route.query?.directory,
  () => {
    getListFolder(route.query?.directory)
  }
)

const images = computed(() => {
  return state.listFolder?.ListDocPub?.filter(item =>
    isImageFile(item.name)
  ).map(item => {
    return {
      src: getImageUrl(route.query?.directory || '', item.name),
      name: item.name
    }
  })
})

const listFiles = computed(() => {
  return state.listFolder?.ListDocPub?.filter(item => item.is_dir)
})

const listImages = computed(() => {
  return state.listFolder?.ListDocPub?.filter(item => isImageFile(item.name))
})
</script>
<style lang="scss" scoped>
.breadcrumb {
  display: flex;
  cursor: pointer;
  min-height: 27px;
  content: "";

  svg {
    align-self: center;
    place-self: center;
  }
  span {
    padding-left: 0.3em;
    color: $blue;
    font-size: 16px;
    font-weight: 600;
  }
}
.card-container {
  width: 100%;
  display: flex;

  .card-content {
    display: flex;
  }
  .card-document {
    cursor: pointer;
    display: grid;
    flex-direction: column;
    background-color: #fff;
    border-radius: 10px;
    // justify-content: center;
    grid-template-rows: 1fr 1fr;
    min-width: 180px;
    max-width: 190px;
    height: 180px;
    padding: 1rem;
    margin: 1rem 1rem 0 0;
    img {
      object-fit: cover;
    }

    &:hover {
      box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__text {
      display: flex;
      justify-content: center;
      align-self: center;
      font-weight: 600;
      text-align: center;
      word-break: normal;
    }
  }
}

.card-image {
  cursor: pointer;
  max-width: 200px;
  margin: 1rem 1rem 0 0;

  .content-info {
    display: flex;
    flex-direction: column;

    .content-name {
      font-weight: 500;
      word-break: break-all;
    }
    span {
      text-align: center;
    }
  }

  &:hover {
    transform: scale(1.05);
    transition: transform 230ms ease-in-out;
  }
}
</style>
